import { render, staticRenderFns } from "./IntentLeader.vue?vue&type=template&id=28c000df&scoped=true"
import script from "./IntentLeader.vue?vue&type=script&lang=js"
export * from "./IntentLeader.vue?vue&type=script&lang=js"
import style0 from "./IntentLeader.vue?vue&type=style&index=0&id=28c000df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c000df",
  null
  
)

export default component.exports